import React from 'react';
import Navbar from './component/Navbar';
import Home from './component/Home';
import Tentang from './component/Tentang';
import Kontak from './component/Kontak';
import Cara from './component/Cara';
import Infaq from './component/Infaq';
import Beli from './component/Beli';
import Keranjang from './component/Keranjang';
import Bayar from './component/Bayar';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
function App() {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/bayar">
            <Navbar />
            <Bayar />
          </Route>
          <Route path="/keranjang">
            <Navbar />
            <Keranjang />
          </Route>
          <Route path="/kontak">
            <Navbar />
            <Kontak />
          </Route>
          <Route path="/infaq">
            <Navbar />
            <Infaq />
          </Route>
          <Route path="/cara">
            <Navbar />
            <Cara />
          </Route>
          <Route path="/beli">
            <Navbar />
            <Beli />
          </Route>
          <Route path="/tentang">
            <Navbar />
            <Tentang />
          </Route>
          <Route path="/home">
            <Navbar />
            <Home />
          </Route>
          <Route path="/">
            <Navbar />
            <Home />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
